<template>
    <section class="container mt-5 mb-5">
        <div class="set-password__container mt-5 mb-5" v-if="passwordChanged === false">
            <h3 class="title-content">{{ $t('SET_PASSWORD') }}</h3>
            <p class="set-password__heading">{{ $t('SET_PASSWORD_TO_ACCOUNT') }}</p>
            <p class="set-password__heading">{{ $t('SAVE_PASSWORD_SHOULD') }}</p>
            <form class="form--main mt-5 mb-5">
                <div class="form-group">
                    <div class="control">
                        <p v-if="errors.has('password') || errors.has('repeatPassword')" class="validate-danger">
                            <img src="./../../../assets/images/icons/excl-red.svg" />
                            {{ $t('COMPLETE_FIELDS_CORRECTLY') }}
                        </p>
                        <input
                            id="password"
                            v-model="password"
                            v-validate="{ required: true, regex: passwordRegex }"
                            data-vv-validate-on="none"
                            :class="{ validate: errors.has('password') }"
                            class="text-input -white-input-border"
                            name="password"
                            :placeholder="$t('PASSWORD')"
                            type="password"
                        />
                        <br /><br />
                        <input
                            id="repeatPassword"
                            v-model="repeatPassword"
                            v-validate="{ required: true, regex: passwordRegex, confirmed: password }"
                            data-vv-validate-on="none"
                            :class="{ validate: errors.has('repeatPassword') }"
                            class="text-input -white-input-border"
                            name="repeatPassword"
                            :placeholder="$t('PASSWORD_CONFIRM')"
                            type="password"
                        />
                    </div>
                </div>
                <button class="app-btn app-btn--big app-btn-primary" @click.prevent="remindPassword">
                    {{ $t('SEND_WITHOUT_DOT') }}
                </button>
            </form>
        </div>

        <div class="text-xs-center mt-5 mb-5" v-else>
            <p class="forgot-password-sent">
                <img src="./../../../assets/images/icons/check-red.svg" />
                {{ $t('PASSWORD_CORRECTLY_CHANGED') }}
            </p>

            <button class="app-btn app-btn--big app-btn-primary" @click.prevent="goToLogin">
                {{ $t('GO_BACK_TO_LOGIN_PAGE') }}
            </button>
        </div>
    </section>
</template>

<script>
import { config } from './../../../main';

export default {
    data() {
        return {
            passwordRegex: config.passwordRegex,
            password: '',
            repeatPassword: '',
            passwordChanged: false,
            token: this.$route.params.token,
        };
    },
    methods: {
        remindPassword() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$http
                        .post('/user/public/registration/finalizePasswordReset/', {
                            password: this.password,
                            token: this.token,
                        })
                        .then(() => (this.passwordChanged = true));
                }
            });
        },
        goToLogin() {
            this.$router.push('/logowanie');
        },
    },
};
</script>

<style lang="scss">
.set-password__container {
    width: 70%;
    max-width: 815px;
    margin-left: auto;
    margin-right: auto;
}

.set-password__heading {
    color: #706c69;
    font-weight: 500;
    display: block;
    font-size: 18px;
}

.forgot-password-sent {
    position: relative;
    padding-left: 60px;
    color: #333333;
    font-size: 18px;
    line-height: 20px;
    font-weight: 800;
    width: 400px;
    margin: 30px auto;
    text-align: left;

    img {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// password-reminder-finish.vue?1378f2c1